<template>
  <div>
    <el-form :model="d_form" :rules="rules" ref="d_form" label-width="100px" class="demo-d_add_form">
      
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="包间名称" prop="room_name" >
            <el-input v-model="d_form.room_name" placeholder="请输入包间名称" :disabled="b_disabled"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="请选择所属店铺" prop="shop_id" label-width="120px">
            <el-select v-model="d_form.shop_id" :disabled="b_disabled" filterable placeholder="请选择所属店铺">
              <el-option
                v-for="item in l_shop_list"
                :key="item.shop_id"
                :label="item.shop_name"
                :value="item.shop_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="包间玩法" prop="play_list" >
          <el-select v-model="d_form.play_list" :disabled="b_disabled" clearable multiple placeholder="请选择包间可用玩法" style="width:100%">
            <el-option
              v-for="item in d_majiang_play"
              :key="item.play_id"
              :label="item.play_name"
              :value="item.play_id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="当前玩法" prop="play_deploy_now" >
          <el-select v-model="d_form.play_deploy_now" :disabled="b_disabled" clearable placeholder="请选择包间可用玩法" style="width:100%">
            <el-option
              v-for="item in d_majiang_play"
              :key="item.play_id"
              :label="item.play_name"
              :value="item.play_id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="包间状态" prop="room_status" >
          <el-select v-model="d_form.room_status" :disabled="b_disabled" clearable placeholder="新建默认包间状态为空闲" style="width:100%">
            <el-option
              v-for="item in d_room_status"
              :key="item.code"
              :label="item.status"
              :value="item.code">
            </el-option>
          </el-select>
      </el-form-item>

      
      <!-- 是否有窗户 -->
      <el-row>
        <el-col :span="3">
          <el-form-item label="是否启用" prop="is_use" >
            <el-switch v-model="d_form.is_use" :disabled="b_disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item label="含窗" prop="is_window" >
            <el-switch v-model="d_form.is_window" :disabled="b_disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item label="沙发" prop="is_sofa" >
            <el-switch v-model="d_form.is_sofa" :disabled="b_disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item label="茶几" prop="is_tea_table" >
            <el-switch v-model="d_form.is_tea_table" :disabled="b_disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item label="排气扇" prop="is_exhaust_fan" >
            <el-switch v-model="d_form.is_exhaust_fan" :disabled="b_disabled"></el-switch>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item label="包间面积" prop="room_area" >
            <el-input-number v-model="d_form.room_area" controls-position="right" :min="0" :max="1000" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-divider><i class="el-icon-money"> 价格配置 | 单位:元</i></el-divider>
        </el-col>

        <el-col :span='6'>
          <el-form-item label="1小时价格" prop="room_area" >
            <el-input-number v-model="d_form.one_hour_price" controls-position="right" :min="1" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span='6'>
          <el-form-item label="4小时价格" prop="room_area" >
            <el-input-number v-model="d_form.four_hour_price" controls-position="right" :min="1" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span='6'>
          <el-form-item label="8小时价格" prop="room_area" >
            <el-input-number v-model="d_form.eight_hour_price" controls-position="right" :min="1" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span='6'>
          <el-form-item label="包夜价格" prop="room_area" >
            <el-input-number v-model="d_form.night_price" controls-position="right" :min="1" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-divider>
            <i class="el-icon-time"> 自定义时间价格配置,时间单位:小时,价格单位:元 | 注:如果不进行自定义价格配置,则都为0</i>
          </el-divider>
        </el-col>

        <el-col :span="6">
          <el-form-item label="自定义时间" prop="room_area" >
            <el-input-number v-model="d_form.custom_time" controls-position="right" :min="0" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="自定义价格" prop="room_area" >
            <el-input-number v-model="d_form.custom_time_price" controls-position="right" :min="0" :disabled="b_disabled"></el-input-number>
          </el-form-item>
        </el-col>

      </el-row>
      
      <el-divider><i class="el-icon-upload"> 上传图片</i></el-divider>

      <el-row :gutter="22">

        <el-col :span="12">
          <el-form-item label="包间主图">
              <el-upload
                :disabled="b_disabled"
                action=""
                list-type="picture-card"
                :limit=1
                :file-list="room_main_img_list"
                :on-success="upload_main_success"
                :http-request="upload_main_img"
                :before-remove="remove_main_img">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="room_main_img_dialog">
                <img width="100%" :src="room_main_img_dialog_url" alt="">
              </el-dialog>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="包间位置图" prop="room_position_img" >
              <el-upload
                :disabled="b_disabled"
                action=""
                list-type="picture-card"
                :limit=1
                :file-list="room_position_img_list"
                :on-success="upload_position_success"
                :http-request="upload_position_img"
                :before-remove="remove_position_img">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="room_main_img_dialog">
                <img width="100%" :src="room_main_img_dialog_url" alt="">
              </el-dialog>
          </el-form-item>
        </el-col>

      </el-row>

      <el-form-item label="包间次图" prop="room_img_list" >
          <el-upload
            :disabled="b_disabled"
            action=""
            list-type="picture-card"
            :limit=5
            :file-list="room_img_list"
            :on-success="upload_minor_success"
            :http-request="upload_minor_img"
            :before-remove="remove_minor_img">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="room_main_img_dialog">
            <img width="100%" :src="room_main_img_dialog_url" alt="">
          </el-dialog>
        </el-form-item>

    <el-form-item >
      <el-button type="primary" @click="save_room_info('d_form')" :disabled="b_disabled">{{ s_btn_name }}</el-button>
      <el-button @click="cancel_func">取消</el-button>
    </el-form-item>

    </el-form>
  </div>
    
</template>

<script>
export default {
  name: 'room_info',
  props: ['DialogType', 'dSelectRoomData'],

  data() {
    return {
      // 包间主图默认不隐藏上传图片
      room_main_img_upload: false,
      // 包间主图上传个数限制
      i_main_upload_limit:1,
      // dialogVisible
      room_main_img_dialog: false,
      room_main_img_dialog_url: '',

      l_shop_list: [],
      
      // 是否禁用表单
      b_disabled: false,
      
      // 表单状态
      dialog_type: this.DialogType,
      // 表单数据
      d_select_room: this.dSelectRoomData,

      // 按钮名称
      s_btn_name: '立即创建',

      d_room_status: [
        {code: 0, status: '空闲中'},
        {code: 1, status: '使用中'},
        {code: 2, status: '锁定中'},
        {code: 3, status: '待打扫'},
        {code: 4, status: '待维修'},
        {code: 5, status: '更改玩法'},
      ],

      // 包间主图 file list
      room_main_img_list: [],

      // 包间位置图 file-list
      room_position_img_list: [],

      // 包间次图 file-list
      room_img_list: [],
      
      // 最终表单信息
      d_form: {},

      // 新增包间表单
      d_add_from: {
        room_name: '',
        room_status: 0,
        shop_id:'',

        room_img_list: [],
        room_main_img: '',
        room_position_img: '',

        is_use: false,
        is_window: false,
        is_sofa: false,
        room_area: 0,
        play_list: [],
        is_window: false,
        is_sofa:false,

      },

      // 包间玩法
      d_majiang_play: [],

      rules: {
        room_name: [
          { required: true, message: '请输入包间名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        shop_id: [
          { required: true, message: '请选择所属店铺', trigger: 'change' },
        ]
      }
    }
  },

  // 一开始就执行的函数
  mounted() {
    // 获取店铺信息
    let _this = this
    let s_shops_url = '/api/shops/'
    
    _this.$axios.get(s_shops_url).then(function(res){
      console.log(res.data)
      _this.l_shop_list = res.data
    })

    _this.d_form = _this.d_add_from

    // 获取当前玩法
    let s_play_url = '/api/play_deploy/'
    
    var d_query_play_data = {"query_list": ["play_name"]}
    console.log(d_query_play_data)

    _this.$axios.get(s_play_url, {params: d_query_play_data}).then(function(res){
      _this.d_majiang_play = res.data
    })

    console.log(this.d_select_room)

    if (this.dialog_type === 1) {
      this.d_form = JSON.parse(JSON.stringify(this.d_add_from))
      this.s_btn_name = '立即创建'
    
    } else if (this.dialog_type === 2) {
      this.d_form = JSON.parse(JSON.stringify(this.d_select_room))
      this.s_btn_name = '立即修改'
      // 包间主图 file list
      this.room_main_img_list = [{url: this.d_form.room_main_img}]

      // // 包间位置图 file-list
      this.room_position_img_list = [{url: this.d_form.room_position_img}]

      // 包间次图 file-list
      for (var i_index=0; i_index<this.d_form.room_img_list.length; i_index++){
        var url = this.d_form.room_img_list[i_index]
        this.room_img_list.push({url: url})
      }

    } else if (this.dialog_type === 3) {
      this.d_form = JSON.parse(JSON.stringify(this.d_select_room))
      this.s_btn_name = '禁止操作'
      this.b_disabled = true
      // 包间主图 file list
      this.room_main_img_list = [{url: this.d_form.room_main_img}]

      // // 包间位置图 file-list
      this.room_position_img_list = [{url: this.d_form.room_position_img}]

      // 包间次图 file-list
      for (var i_index=0; i_index<this.d_form.room_img_list.length; i_index++){
        var url = this.d_form.room_img_list[i_index]
        this.room_img_list.push({url: url})
      }
    }

  },

  // 自定义接口
  methods: {
    // 包间主图 上传
    async upload_main_img(option){
      const res = await this.upload_common(option)
      this.d_form.room_main_img = res.data.s_url
    },

    // 上传包间主图成功回调
    upload_main_success(response, file, fileList){
      console.log(file.url)
    },

    // 删除包间主图
    async remove_main_img(){
      let s_remove_url = this.d_form.room_main_img
      await this.remove_common(s_remove_url)
      this.d_form.room_main_img = ''
    },
    
    // 上传包间位置图
    async upload_position_img(option){
      const res = await this.upload_common(option)
      this.d_form.room_position_img = res.data.s_url
    },
    

    // 删除包间位置图
    async remove_position_img(){
      let s_remove_url = this.d_form.room_position_img
      await this.remove_common(s_remove_url)
      this.d_form.room_position_img = ''
    },

    // 上传包间位置图成功回调
    upload_position_success(){
      
    },

    // 上传包间次图
    async upload_minor_img(option){
      const res = await this.upload_common(option)
      this.d_form.room_img_list.push(res.data.s_url)
      console.log(this.d_form.room_img_list)
    },

    // 删除包间次图
    async remove_minor_img(file, fileList){
      let s_remove_url = file.url
      await this.remove_common(s_remove_url)
      this.d_form.room_img_list.splice(fileList.indexOf(file), 1)
      console.log(this.d_form.room_img_list)
    },

    // 上传包间次图成功回调
    upload_minor_success(){
      
    },
    
    // 上传文件通用接口
    upload_common(option){
      
      let p_file = option.file
      let l_file_type = p_file.type
      let b_is_image = l_file_type.indexOf("image") != -1

      // 是否图片
      if (!b_is_image) {
        this.$message.error("只能上传图片格式png、jpg");
        return
      }

      // form 表单
      let d_form_data = new FormData()

      d_form_data.append("file", p_file)
      d_form_data.append('folder', "room_main_img")
      let url= '/api/upload_file/'

      let res = this.$axios.post(
          url, d_form_data, {headers: {"content-type": "multipart/form-data"}}
      )
      console.log(res)
      console.log(res.data)
      return res
    },

    // 删除文件通用接口
    remove_common(s_remove_url){
      let url = "/api/remove_file/"
      let d_data = {'s_url': s_remove_url}
      let res = this.$axios.post(url, d_data)
      console.log(res)
      return res
    },

    // 关闭表单
    cancel_func(){
      this.$emit("RoomInfoCallback", false)
    },

    // 保存包间信息
    save_room_info(formName){
      console.log(this.d_form)
      var _this = this
      this.$refs[formName].validate(function(valid){
        if (valid) {
          // 验证通过
          _this.save_room_info_submit()
        } else {
          // 验证不通过
          console.log('error submit!!')
          return false
        }
      })
    },
    
    // 保存包间信息提交
    async save_room_info_submit(){

      // 判断当前玩法是否在可用玩法列表中
      let d_data = JSON.parse(JSON.stringify(this.d_form))

      // 判断 d_data.play_deploy_now 是否在数组 d_data.play_list 中
      let b_is_in_play_list = false
      for (var i_index=0; i_index<d_data.play_list.length; i_index++){
        if (d_data.play_deploy_now == d_data.play_list[i_index]){
          b_is_in_play_list = true
          break
        }
      }

      if (!b_is_in_play_list){
        this.$message.error("当前玩法不在包间的可用玩法列表中")
        return
      }
      
      if (this.dialog_type === 1){
        let s_url = '/api/rooms/'
        let res = await this.$axios.post(s_url, d_data)
        this.request_waring(res)
      }else{
        let s_url = '/api/rooms/' + this.d_form.room_id + '/'
        let res = await this.$axios.put(s_url, d_data)
        this.request_waring(res)
      }
    },

    // 请求警告
    request_waring(res){
      if (res.status === 201 || res.status === 200){
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.$emit("RoomInfoCallback", false)
      
      } else {
        this.$message({
          message: '保存失败',
          type: 'error'
        })
      }
    },
  }
    
}
</script>

<style >

</style>